import { styled } from "@mui/material";

export const TypeBox = styled("div")`
	padding: 4px 13px;

	background: #eef7ff;
	border-radius: 8px;
`;
